/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const bus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.8 13.133v.934a.933.933 0 1 0 1.867 0v-.934m-1.867 0h8.4m-8.4 0a.933.933 0 0 1-.933-.933V3.8a2.8 2.8 0 0 1 2.8-2.8h4.666a2.8 2.8 0 0 1 2.8 2.8v8.4a.934.934 0 0 1-.933.933m0 0v.934a.933.933 0 1 1-1.867 0v-.934m-5.6-1.866H6.6m2.8 0h1.867m-8.4-5.6h-.934A.933.933 0 0 0 1 6.6v2.8m12.133-3.733h.934A.933.933 0 0 1 15 6.6v2.8M2.867 4.733h10.266V9.4H2.867V4.733Z"
    />
  </svg>
)
export default bus
